import { ExtraUnitType } from 'enums/extraUnitTypes';

export const extraUnitTypeLabels: Record<ExtraUnitType, string> = {
  HEAD_COUNT: 'common:units.headCount',
  HOUR: 'common:units.hour',
  HOUR_RATE: 'common:units.hour',
  RESERVATION: 'common:units.reservation',
  DAY: 'common:units.day',
  WEEK: 'common:units.week',
};
